import React from 'react';
import ReactDOM from "react-dom";
import HelpComponent from '../HelpComponent';

class ModelSetOption extends React.Component{
    constructor(){
        super();
        this.state={
            isSettingOpen:false,
            isHaveModel:false,
            drawMode : "0",
            scale : 1,
            cover : "null",
            helpMode : "None",
            offset : {
                x : 0,
                y : 0,
                z : 0
            },
            Rotate : 0,
            Scale : 1
        };
    }
    componentWillMount(){
        const layer = this.props.layer;
        var ModelSetLayer = this.props.layer.layerHandel;
        if(layer.layerMode!=null){
            if (layer.layerMode) {
                ModelSetLayer.setDrawMode(1, 3);
                this.setState({drawMode:"0",isHaveModel:true});
            } else{
                ModelSetLayer.setDrawMode(0, 0);
                this.setState({drawMode:"1",isHaveModel:false});
            }            
        }
    }
    deleteLayerList(layer){
        const Layer = {
            TITLE:layer.layerName,
            TYPE:layer.layerType
        };
        this.props.deleteLayerList(Layer);
    }
    gotoLayer(){
        var ModelSetLayer = this.props.layer.layerHandel;
        ModelSetLayer.goto();
    }
    settingOpen(){
        this.setState({ isSettingOpen: !this.state.isSettingOpen });
    }
    modeChange(event){
        var ModelSetLayer = this.props.layer.layerHandel; 
        var Mode = event.target.value;
        if(this.state.isHaveModel){
            if (Mode === "0") {
                ModelSetLayer.setDrawMode(1, 3);
            } else if (Mode === "1") {
                ModelSetLayer.setFloorModeScale(1);
                ModelSetLayer.setDrawMode(1, 0);
            } else if (Mode === "2") {
                ModelSetLayer.setDrawMode(1, 1);
            } else if (Mode === "3") {
                ModelSetLayer.setDrawMode(1, 2);
            }
        }
        else{
            if (Mode === "0") {
                ModelSetLayer.setDrawMode(0, 2);
            } else if (Mode === "1") {
                ModelSetLayer.setFloorModeScale(1);
                ModelSetLayer.setDrawMode(0, 0);
            } else if (Mode === "2") {
                ModelSetLayer.setDrawMode(0, 1);
            }
        }        
        this.setState({drawMode:Mode});
    }
    ScaleChange(event){
        var Scale = event.target.value;
        var ModelSetLayer = this.props.layer.layerHandel;
        ModelSetLayer.setFloorModeScale(Scale);
        this.setState({scale : Scale});
    }
    coverChange(event){
        var cover = event.target.value;
        var ModelSetLayer = this.props.layer.layerHandel;
        if(cover === "null"){
            ModelSetLayer.setOverlayName();
            window.main.OView.updateScreen();
        }            
        else{
            ModelSetLayer.setOverlayName(cover);
            window.main.OView.updateScreen();
        }            
        this.setState({cover : cover});
    }
    posXChange(event){
        let offset = this.state.offset;
        offset.x = parseFloat(event.target.valueAsNumber);
        let ModelSetLayer = this.props.layer.layerHandel;
        ModelSetLayer.setOffset(offset);
        this.setState({offset : offset});
    }
    posYChange(event){
        let offset = this.state.offset;
        offset.y = parseFloat(event.target.valueAsNumber);
        let ModelSetLayer = this.props.layer.layerHandel;
        ModelSetLayer.setOffset(offset);
        this.setState({offset : offset});
    }
    posZChange(event){
        let offset = this.state.offset;
        offset.z = parseFloat(event.target.valueAsNumber);
        let ModelSetLayer = this.props.layer.layerHandel;
        ModelSetLayer.setOffset(offset);
        this.setState({offset : offset});
    }
    setRotate(event){
        let Rotate = parseFloat(event.target.valueAsNumber);
        let ModelSetLayer = this.props.layer.layerHandel;
        ModelSetLayer.setRotate(Rotate);
        this.setState({Rotate : Rotate});
    }
    setScale(event){
        let Scale = parseFloat(event.target.valueAsNumber);
        let ModelSetLayer = this.props.layer.layerHandel;
        ModelSetLayer.setScale(Scale);
        this.setState({Scale : Scale});
    }
    onHelpClick(mode){
        this.setState({helpMode:mode})
    }
    render(){
        const LayerList_2D = this.props.LayerList_2D;
        const Layer = this.props.layer;
        const siderRangeCSS ={
            background: "linear-gradient(45deg, rgba(59,173,227,1) 0%, rgba(87,111,230,1) 25%, rgba(152,68,183,1) 51%, rgba(255,53,127,1) 100%)"
        };
        if(this.state.helpMode === "ModelSetHelp" ){
            if(this.state.isHaveModel){
                ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/35jBgg2fzDw" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help'));

            }
            else{
                ReactDOM.render(<HelpComponent videoSrc="https://www.youtube.com/embed/0zpCYGzrjGw" onHelpClick={(e)=>this.onHelpClick(e)} />,document.getElementById('Help'));
            }
        }   
        else if(this.state.helpMode === "None"){
            ReactDOM.unmountComponentAtNode(document.getElementById('Help'));      
        }
        return(
            <div className="ts accordion item">
                <div className="ts grid">
                    <div className="ts ten wide column"  style={{alignSelf: 'center'}}>
                        <div className="ts grid">
                            <div className="ts two wide column">
                                <i className="large building icon"></i>
                            </div>
                            <div className="ts fourteen wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">{Layer.layerName}
                                    <button className="ts circular pulsing mini icon button" style={{fontSize:"10px"}} onClick={(e)=>this.onHelpClick("ModelSetHelp")}>
                                        <i className="help small icon" style={{color:"#919191"}}></i>
                                    </button>
                                </h6>
                            </div>
                        </div>                      
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.deleteLayerList(Layer)} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="關閉圖層">
                        <i className="large remove circle outline icon"></i>
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.gotoLayer()} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="前往圖層位置">
                        <i className="large marker icon"></i>
                    </div>
                    <div className="ts two wide column" style={{cursor:"pointer"}} onClick={(e)=>this.settingOpen()} data-tooltip-position="top center" data-tooltip-type="label" data-tooltip="圖層設定">
                        <i className="large setting icon"></i>
                    </div>
                </div>
                {
                    this.state.isSettingOpen?
                    <div className="ts very narrow container segment" >
                        <div className="ts grid">
                            <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">繪製模式：</h6>
                            </div>
                            <div className="ts six wide column">
                                {
                                    this.state.isHaveModel?
                                    <select className="ts borderless basic dropdown" onChange={(e)=>this.modeChange(e)} value={this.state.drawMode} style={{width:"100%"}}>
                                        <option value="0">原貼圖</option>
                                        <option value="1">依樓層分層</option>
                                        <option value="2">依高度分層</option>
                                        <option value="3">純色</option>
                                    </select>
                                    :
                                    <select className="ts borderless basic dropdown" onChange={(e)=>this.modeChange(e)} value={this.state.drawMode} style={{width:"100%"}}>
                                        <option value="0">純色</option>
                                        <option value="1">依樓層分層</option>
                                        <option value="2">依高度分層</option>
                                    </select>
                                }
                            </div>
                        </div>
                        {
                            this.state.drawMode === "2" ? 
                            <div>
                                <div className="ts grid">
                                    <h4 className="ts nine wide column">繪製比例:</h4>
                                    <label className="ts seven wide column" style={{alignSelf: 'center',textAlign: 'center'}}>每{this.state.scale}公尺繪製一層</label>
                                </div>
                                
                                <div className="ts grid">                    
                                    <input type="range" min="1" max="100" defaultValue={this.state.scale} step="1" onChange={(e)=>this.ScaleChange(e)} style={siderRangeCSS}></input>
                                </div>
                            </div> : null
                        }
                        <div className="ts grid">
                            <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">影像披覆：</h6>
                            </div>
                            <div className="ts six wide column">
                                <select className="ts borderless basic dropdown" onChange={(e)=>this.coverChange(e)} value={this.state.cover} style={{width:"100%"}}>
                                    <option value="null">無</option>
                                    {
                                        LayerList_2D.map(
                                            (layer)=>
                                                <option value={layer.layerName}>{layer.layerName}</option> 
                                        )
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="ts grid">
                            <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">X座標平移量：</h6>
                            </div>
                            <div className="ts six wide column">
                                <div class="ts mini circular input">
                                    <input type="number" id="posX" style={{width:"100%"}}  value={this.state.offset.x} onChange={(e)=>this.posXChange(e)}></input>
                                </div>
                            </div>
                        </div>
                        <div className="ts grid">
                            <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">Y座標平移量：</h6>
                            </div>
                            <div className="ts six wide column">
                                <div class="ts mini circular input">
                                    <input type="number" id="posY" style={{width:"100%"}}  value={this.state.offset.y} onChange={(e)=>this.posYChange(e)}></input>
                                </div>
                            </div>
                        </div>
                        <div className="ts grid">
                            <div className="ts ten wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">Z座標平移量：</h6>
                            </div>
                            <div className="ts six wide column">
                                <div class="ts mini circular input">
                                    <input type="number" id="posZ" style={{width:"100%"}} value={this.state.offset.z} onChange={(e)=>this.posZChange(e)}></input>
                                </div>
                            </div>
                        </div>
                        <div className="ts grid">
                            <div className="ts six wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">旋轉：</h6>
                            </div>
                            <div className="ts ten wide column">
                                <div class="ts fluid slider" style={{boxShadow:"none"}}>
                                    <div class="ts basic right pointing label">{this.state.Rotate}</div>
                                    <input type="range" min="0" max="360" step="0.5" value={this.state.Rotate} onChange={(e)=>this.setRotate(e)}></input>
                                </div>
                            </div>
                        </div>
                        <div className="ts grid">
                            <div className="ts six wide column" style={{alignSelf: 'center'}}>
                                <h6 className="layerNameCSS">縮放：</h6>
                            </div>
                            <div className="ts ten wide column">
                                <div class="ts fluid slider" style={{boxShadow:"none"}}>
                                    <div class="ts basic right pointing label">{this.state.Scale}</div>
                                    <input type="range" min="0.1" max="5" step="0.1" value={this.state.Scale} onChange={(e)=>this.setScale(e)}></input>
                                </div>
                            </div>
                        </div>
                    </div> : null
                }
                
            </div>
        );
    }
}

class ModelSetLayer extends React.Component{
    constructor(){
        super();
        this.state = {
            isChecked:false,
            modelSetLayer:{}
        };   
        this.modelSetLayerChecked = this.modelSetLayerChecked.bind(this);      
    }
    componentDidUpdate(){
        if(this.props.deleteList.layerName === this.props.layer.TITLE){
            let isChecked = this.state.isChecked;
            if(isChecked){
                window.main.OView.removeLayer(this.state.modelSetLayer);
                window.alertify.error("已關閉圖層："+this.props.layer.TITLE);
                isChecked = !isChecked;
                this.setState({isChecked:isChecked,modelSetLayer:{}});
            }            
        }
    }
    modelSetLayerChecked(layer){
        let isChecked = this.state.isChecked;
        const layerThis = this;             
        if(!isChecked){
            window.main.OView.addModelSetLayer({
                url: window.TERRAIN_SERVER.URL,
                identifier: layer.ID,
                urlTemplate: window.TERRAIN_SERVER.URLTemplate,
                callback: function (e,modelSetLayer) {
                    if(e){
                        modelSetLayer.goto();
                        window.alertify.success("已開啟圖層："+layer.TITLE);
                        layerThis.props.setOpenLayer(layer,modelSetLayer);                        
                        isChecked = !isChecked;
                        layerThis.setState({isChecked:isChecked,modelSetLayer:modelSetLayer});
                    }
                    else if(!e){
                        window.alertify.error("連結不到圖層:："+layer.TITLE);
                    }
                }
            });               
        }
        else{
            window.main.OView.removeLayer(this.state.modelSetLayer);
            layerThis.props.deleteLayer(layer);
            window.alertify.error("已關閉圖層："+layer.TITLE);            
            isChecked = !isChecked;    
            layerThis.setState({isChecked:isChecked,modelSetLayer:{}});        
        }                      
    }    
    render(){
        const layer = this.props.layer;
        return(
            <div className="ts checkbox">
                <input type="checkbox" name="ModelSetLayer" id={layer.TITLE} checked={this.state.isChecked} onChange={(e)=>this.modelSetLayerChecked(layer)}></input>
                <label htmlFor={layer.TITLE}>{layer.TITLE}</label>
            </div>
        );
    }
}

export  {ModelSetLayer,ModelSetOption};